import { render, staticRenderFns } from "./SignArtistSearchCustom.vue?vue&type=template&id=caf491b0&scoped=true"
import script from "./SignArtistSearchCustom.vue?vue&type=script&lang=js"
export * from "./SignArtistSearchCustom.vue?vue&type=script&lang=js"
import style0 from "./SignArtistSearchCustom.vue?vue&type=style&index=0&id=caf491b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf491b0",
  null
  
)

export default component.exports